<template>
  <div class="empty-result" :style="{ backgroundColor }">
    <slot name="icon">
      <YorkbbsImage width="305px" height="150px" class="m-auto" :src="icon" />
    </slot>
    <slot>
      <div class="empty-result__text">{{ text }}</div>
    </slot>
  </div>
</template>
<script>
export default {
  name: 'EmptyResult',
  props: {
    // 图标
    icon: {
      type: String,
      default: require('./images/empty.png'),
    },
    // 文字
    text: {
      type: String,
      default: '暂无数据',
    },
    // 背景颜色
    backgroundColor: {
      type: String,
      default: '#ffffff',
    },
  },
};
</script>
<style lang="scss" scoped>
.empty-result {
  padding: 100px 0;
}
.empty-result__text {
  font-size: 16px;
  line-height: 22px;
  color: #999999;
  text-align: center;
  margin-top: 20px;
}
</style>
